export default __webpack_public_path__ + "e6e59cabe8df91142cddc566557e55f4.jpg";